<template>
  <div class="sned_notice-root notice-root">
    <div class="main-content-wrap">
      <div class="nav_filter_wrap">
        <div class="up_wrap">
          <div class="icon" @click="goBack">
            <v-icon name="regular/arrow-alt-circle-left" scale="1.5"></v-icon>
          </div>
          <div class="main_wrap">
            <div class="left">
              <a
                v-for="(item, index) in nav"
                :key="index"
                :class="{'btn': true, active: $route.name === item.routerName}"
                @click="navLink(item)"
              >{{item.name}}</a>
            </div>
            <div class="right">
              <div class="zuxie-btn" @click="createNotice" v-if="isSendNotice">新增通知</div>
            </div>
          </div>
        </div>
      </div>
      <div class="classMain">
        <div class="searchWrap">
          <div class="selectWrap">
            <select v-model="selectVal.user" @change="search">
              <option value>全部角色</option>
              <option v-for="item in usersList" :key="item.value" :value="item.value">{{ item.key }}</option>
            </select>
            <el-date-picker
              class="date-input"
              :editable="false"
              v-model="selectVal.start_time"
              :picker-options='searchStartTime'
              type="date"
              value-format="timestamp"
              placeholder="开始时间"
              @change="search()"
            ></el-date-picker>
            <el-date-picker
              class="date-input"
              :editable="false"
              v-model="selectVal.end_time"
              type="date"
              value-format="timestamp"
              :picker-options="searchTime"
              @change="search()"
              placeholder="结束时间"
            ></el-date-picker>
          </div>
          <div class="search">
            <div class="wrap">
              <input
                type="text"
                placeholder="请输入搜索内容"
                v-model.lazy="selectVal.keywords"
                @keyup.enter="search"
              >
              <div v-show="selectVal.keywords!=''" class="close" @click="hideIcon">
                <v-icon name="regular/times-circle" scale="1.2"></v-icon>
              </div>
            </div>
            <div class="searchBtn" @click="search">搜索</div>
          </div>
        </div>
        <yioks-loading v-show="isLoading"></yioks-loading>
        <template v-if="!isLoading">
          <template v-if="!showEmpty">
            <div class="table">
              <div class="thead">
                <div class="tr">
                  <div class="th org">
                    <strong>接收用户</strong>
                  </div>
                  <div class="th tit">
                    <strong>标题</strong>
                  </div>
                  <!-- <div class="th type">
                    <strong>类型</strong>
                  </div> -->
                  <div class="th send">
                    <strong>发送人</strong>
                  </div>
                  <div class="th time">
                    <strong>发布时间</strong>
                  </div>
                  <div class="th push">
                    <strong>强制推送</strong>
                  </div>
                  <div class="th statu">
                    <strong>阅读状态</strong>
                  </div>
                </div>
              </div>
              <div class="scrollArea">
                <vue-scroll :ops="ops" ref="vs">
                  <div class="tbodyWrap">
                    <div class="tbody">
                      <div class="tr" v-for="(item, index) in noticeList" :key="item.notification_id">
                        <div class="td org">
                          <p>{{item.user_level | userRole}}</p>
                        </div>
                        <div class="td tit">
                          <p @click="lookContent(item, index)">{{item.title}}</p>
                        </div>
                        <!-- <div class="td type">
                          <p>{{item.type | noticeType}}</p>
                        </div> -->
                        <div class="td send">
                          <p>{{item.expediter}}</p>
                        </div>
                        <div class="td time">
                          <p>{{item.create_time | time(true)}}</p>
                        </div>
                        <div class="td push">
                          <p>{{item.push === 1 ? "是" : "否"}}</p>
                        </div>
                        <div class="td statu">
                          <p @click="lookStatus(item)">{{item.is_read_num}}/{{item.user_number}}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </vue-scroll>
              </div>
            </div>
            <div class="paging">
              <yioks-paging :paging="paging" @goto-page="gotoPage($event)"></yioks-paging>
            </div>
          </template>
          <div class="empty_wrap" v-show="showEmpty">
            <yioks-empty h="100%"></yioks-empty>
          </div>
        </template>
      </div>
    </div>
    <notice-detail-dialog @know='iRead' @hideDia="closeDetail" :if-show="ifContentDiaShow" :info="noticeInfo"></notice-detail-dialog>
    <notice-users-dialog :show.sync="ifusersDiaShow" :list="statusList"></notice-users-dialog>
  </div>
</template>

<script>
import NoticeCommon from "../NoticeMinix";
import { allNoticeList, userList } from "@/api/notice/notice";
// import { roleHash, noticeTypes } from "@/assets/js/status";

export default {
  name: "other-notice",
  mixins: [NoticeCommon],
  data() {
    return {
      ifusersDiaShow: false,
      noticeList: [],
      statusList: []
    };
  },
  created() {
    this.setData();
    this.request();
  },
  methods: {
    iRead() {
      // this.request();
    },
    request() {
      this.isLoading = true;
      const selectVal = this.selectVal;
      const { page: thePage } = this;
      allNoticeList({
        title: selectVal.keywords,
        user_level: selectVal.user,
        start_time: selectVal.start_time,
        end_time: selectVal.end_time,
        page: thePage
      })
        .then(({ data: { status, result: { list, page } } }) => {
          if (Number(status) === 0) {
            this.isLoading = false;
            this.noticeList = [...list];
            this.paging = {
              ...this.paging,
              prePage: page.page_size,
              total: page.total_row,
              start: (thePage - 1) * page.page_size
            };
            this.showEmpty = list.length <= 0;
          }
        })
        .catch(err => {
          console.error(err);
          this.isLoading = false;
        });
    },
    lookStatus({ notification_id }) {
      this.statusList = [];
      // 调接口获取数据
      userList({ notification_id })
        .then(({ data: { status, result: { userList } } }) => {
          if (Number(status) === 0) {
            this.statusList = userList;
          }
        })
        .catch(err => {
          console.error(err);
        });
      this.ifusersDiaShow = true;
    },
    // 前往创建通知页面
    createNotice() {
      this.$router.push({ name: "CreateNotice" });
    },
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable';
@import '../notice';

.sned_notice-root {
  .classMain {
    .table {
      /* .check {
        width 10%
        .check_all {
          font-weight bolder
          padding: 5px 9.5px;
          color: #fff;
          font-size inherit
        }
      } */
      .org {
        width: 12%;
      }

      .tit {
        width: 32%;
        /* flex: 1 1 0; */
      }

      .type {
        width: 13%;
      }

      .time {
        width: 20%;
      }

      .statu {
        width: 9%;
      }
      .push {
        width: 9%;
      }
      .send {
        width 18%
      }

      /* .opera {
        width: 7%;
        .icon_wrap {
          padding 5px 
          cursor pointer
          &>svg {
            display block 
          }
        }
      } */
      .tbody {
        .tit, .statu {
          color: $color_suc;
        }

        .tit, .statu {
          p {
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
<style lang="stylus">
@import '../resetStyle.styl';
</style>
